<template>
  <div class="demo flex-grow">
    <div class="w-full sm:w-3/5 md:w-2/5 mx-auto px-4">
      <form action="#" method="post" id="my_form" class="mb-10">
        <h1>Validation demo</h1>

        <label>Form configuration</label>
        <pre>
            <code class="language-javascript">
valForm.init({
  formId: "my_form",
  dateFormat: "YYYY-mm-dd"
});
            </code>
        </pre>

        <div class="input-form mt-4">
          <label for="title">Title</label>
          <div class="html_detail">{name="title" data-val-rules="required" data-val-display="Title"}</div>
          <select name="title" id="title" data-val-rules="required" data-val-display="Title">
            <option value>- Please choose -</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
            <option value="Miss">Miss</option>
          </select>
        </div>

        <div class="input-form">
          <label for>First Name</label>
          <div class="html_detail">{name="name" data-val-rules="required|max_length[12]"}</div>
          <div>
            <p>
              <input type="text" name="name" id="name" data-val-rules="required|max_length[12]" />
            </p>
          </div>
        </div>

        <div class="input-form">
          <label for>Last name</label>
          <div
            class="html_detail"
          >{name="surname" data-val-rules="required|min_length[3]" data-val-display="Last Name"}</div>
          <input
            type="text"
            name="surname"
            id="surname"
            data-val-rules="required|min_length[3]"
            data-val-display="Last name"
          />
        </div>

        <div class="input-form">
          <label for>Date of birth</label>
          <div
            class="html_detail"
          >{name="dob" data-val-rules="required|valid_date|max_years_in_past[99]|years_between[licence:17]" data-val-display="Date of birth" data-val-with="licence"}</div>
          <input
            type="date"
            name="dob"
            v-model="dob"
            id="dob"
            data-val-rules="required|valid_date|date_in_past|max_years_in_past[99]|years_between[licence:17]"
            data-val-display="Date of birth"
            data-val-with="licence"
          />
        </div>

        <div class="input-form">
          <label for>Driving licence date</label>
          <div
            class="html_detail"
          >{name="licence" data-val-rules="required|valid_date|years_between[dob:17]" data-val-display="Licence date" data-val-with="dob"}</div>
          <input
            type="date"
            name="licence"
            v-model="licence"
            id="licence"
            data-val-rules="required|valid_date|years_between[dob:17]"
            data-val-display="Licence date"
            data-val-with="dob"
          />
        </div>

        <div class="input-form">
          <label for>Email</label>
          <div class="html_detail">{name="email" data-val-rules="required|valid_email"}</div>
          <input type="email" name="email" id="email" data-val-rules="required|valid_email" />
        </div>

        <div class="input-form">
          <label for>Phone</label>
          <div
            class="html_detail"
          >{name="phone" data-val-rules="uk_phonenumber" data-val-allow-empty="true"}</div>
          <input
            type="tel"
            name="phone"
            id="phone"
            data-val-rules="uk_phonenumber"
            data-val-allow-empty="true"
          />
        </div>

        <div class="input-form">
          <label for="password">Password</label>
          <div
            class="html_detail"
          >{name="password" data-val-rules="required|matches[password_confirmation]" data-val-display="Password" data-val-with="password_confirmation"}</div>
          <input
            type="password"
            name="password"
            id="password"
            data-val-rules="required|matches[password_confirmation]"
            data-val-display="Password"
            data-val-with="password_confirmation"
          />
        </div>

        <div class="input-form">
          <label for="password">Confirm password</label>
          <div
            class="html_detail"
          >{name="password_confirmation" data-val-rules="required|matches[password]" data-val-with="password"}</div>
          <input
            type="password"
            name="password_confirmation"
            id="password_confirmation"
            data-val-rules="required|matches[password]"
            data-val-display="Password confirmation"
            data-val-with="password"
          />
        </div>

        <div class="input-form">
          <label for>What movies do you like?</label>
          <div
            class="html_detail"
          >{name="movies[]" data-val-rules="required" data-val-display="Movies"}</div>
          <div>
            <input type="checkbox" name="movies[]" value="comedy" /> Comedy
            <input type="checkbox" name="movies[]" value="romance" /> Romance
            <input
              type="checkbox"
              name="movies[]"
              data-val-rules="required"
              data-val-display="Movies"
              value="scifi"
            /> Sci-fi
          </div>
        </div>

        <div class="input-form">
          <label for>What is your gender?</label>
          <div
            class="html_detail"
          >{name="gender" data-val-rules="required" data-val-display="Gender"}</div>
          <div class="wrap">
            <input type="radio" name="gender" value="M" /> Male
            <input
              type="radio"
              name="gender"
              data-val-rules="required"
              value="F"
              data-val-display="Gender"
            /> Female
          </div>
        </div>

        <button
          type="submit"
          @click.prevent="handleSubmit"
          class="bg-green-400 text-white hover:bg-green-500 px-3 py-2 rounded outline-none"
        >Submit</button>

        <div
          v-if="valid"
          class="mt-2 text-xs p-2 bg-green-400 text-white rounded"
        >Form is now valid and could be submitted...</div>
      </form>
    </div>
  </div>
</template>

<script>
import valForm from "valform";

export default {
  name: "demo",
  data() {
    return {
      dob: "",
      licence: "",
      valid: false
    };
  },
  mounted() {
    valForm.init({
      formId: "my_form",
      // validationErrorClass: "error-bejby",
      // validationValidClass: "valid-bejby",
      // errorElement: ""
      // appendAfter: "input-form",
      dateFormat: "YYYY-mm-dd"
    });

    Prism.highlightAll();
  },
  methods: {
    async handleSubmit() {
      let check = await valForm.validateForm();

      if (check) {
        this.valid = true;
      }
    }
  }
};
</script>

<style>
.input-form {
  @apply mb-4 w-full;
}

label {
  @apply block;
}

input,
select {
  @apply w-full p-2 border border-gray-400 outline-none;
}

input[type="checkbox"],
input[type="radio"] {
  width: auto;
}

div.wrap:has(input[type="checkbox"].val--error),
div:has(input[type="radio"].val--error) {
  backround-color: pink;
}

input.val--error,
select.val--error {
  @apply border-red-400;
}

small.val--error {
  @apply text-red-400;
}

input.val--valid,
select.val--valid {
  @apply border-green-400;
}

.html_detail {
  @apply p-1 bg-gray-200 font-monospace text-xxs italic w-full break-all;
}
</style>
